import {
  APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_BEGIN,
  APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_SUCCESS,
  APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_FAILURE,
  APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function toggleProjectCustomJs(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/toggle-custom-js`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissToggleProjectCustomJsError() {
  return {
    type: APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_BEGIN:
      return {
        ...state,
        toggleProjectCustomJsPending: true,
        toggleProjectCustomJsError: null,
      };

    case APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_SUCCESS:
      return {
        ...state,
        toggleProjectCustomJsPending: false,
        toggleProjectCustomJsError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_FAILURE:
      return {
        ...state,
        toggleProjectCustomJsPending: false,
        toggleProjectCustomJsError: action.data.error,
      };

    case APP_SETTING_TOGGLE_PROJECT_CUSTOM_JS_DISMISS_ERROR:
      return {
        ...state,
        toggleProjectCustomJsError: null,
      };

    default:
      return state;
  }
}
